import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {defaultVariabls} from "../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import SubTitle from "../../components/elements/SubTitle";
import Grid from "@material-ui/core/Grid/Grid";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import {currencySymbol, price} from "../../../config/values";
import Card from "@material-ui/core/Card/Card";
import Typography from "@material-ui/core/Typography/Typography";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import {Translate} from "../../../config/Translate";
import Button from "@material-ui/core/Button/Button";
import axios from "axios";
import {connect, setStore} from "trim-redux";
import {getLimitUsage, hasProductLimit, LoadSetting, updateRedux} from "../../../config/Security";
import SubTitleLight from "../../components/elements/SubTitleLight";
import FieldCounterTotal from "../../components/elements/FieldCounterTotal";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import {Link} from "react-router-dom";
import AccountBalanceWalletTwoToneIcon from '@material-ui/icons/AccountBalanceWalletTwoTone';
import LoadingButton from "../../components/elements/LoadingButton";
class BuyPackage extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();
    }
    state = {
        loading: true,
        packages:[],
        total:0,
    };
    classes = this.props.classes;
    async componentDidMount(){
        let {user} = this.props;
        let total = 0;
        if(user.role.type === "admin"){
            total = 0;
        }else{
            if(!!user.shops[0]){
                total = user.shops[0].products_count
            }
        }
        this.setState({
            total
        })
        await this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/packages/getAllForChooser`, config)
                .then(response => {
                    this.setState({
                        packages: response.data,
                        loading:false,
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    async buyWithWallet(id){
        this.setState({
            SubmitLoading: true
        })
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/buy_package_with_wallet`, data, config)
            .then(async response => {
                this.props.enqueueSnackbar(Translate.orderPayed, {
                    variant: 'success',
                });
                await updateRedux();
                await LoadSetting();
                await this.setState({
                    loading:true,
                    SubmitLoading: false,
                });
                await this.props.history.push('/my-products')

            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.orderPayingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });
    }

    render(){
        let {packages,loading,SubmitLoading} = this.state;
        let {user} = this.props;
        let amount = !!user ? user.wallet.amount : 0 ;

        return (
            <>
                {
                    !!loading ?
                        <AppCardLoaderFields/> :
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {
                                    (!!hasProductLimit()) ?
                                    <Grid item xs={12}>
                                        <SubTitleLight align="left">{Translate.productLimit}</SubTitleLight>
                                        <FieldCounterTotal length={getLimitUsage()} max={hasProductLimit()}/>
                                    </Grid> :
                                    <Grid item xs={12}>
                                        <Alert severity="info"
                                               action={
                                                   <Button color="inherit" size="small" component={Link} to={'/my-products'}>
                                                       {Translate.myProducts}
                                                   </Button>
                                               }
                                        >
                                            <AlertTitle>{Translate.youDontNeedToPurchase}</AlertTitle>
                                            {Translate.youDontNeedToPurchaseDesc}
                                        </Alert>
                                    </Grid>
                                }
                            </Grid>
                            {
                                packages.map((item,index) =>(
                                    <Grid item xs={12} md={4} lg={3} key={index}>
                                        <Card style={{padding:20,textAlign:"center"}}>
                                            <img style={{maxWidth:75}} alt={item.name} src={`${defaultVariabls.uploads}/FileManager/${item.thumbnail.name}.${item.thumbnail.extension}`} />
                                            <SubTitle>{item.name}</SubTitle>
                                            <SubTitleLight>
                                                <strong>{item.count}</strong> {Translate.productToBuy}
                                            </SubTitleLight>
                                            <Typography style={{margin:"20px 0"}}>
                                                {
                                                    !!item.discount_price ?
                                                        <>
                                                            <del>{price(item.price)}</del> <strong>{price(item.discount_price)}</strong> <span>{currencySymbol}</span>
                                                        </> :
                                                        <>
                                                            <strong>{price(item.price)}</strong> <span>{currencySymbol}</span>
                                                        </>
                                                }
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{width:"100%"}}
                                                component={"a"}
                                                href={`${defaultVariabls.website}/package/pay/${item.id}`}
                                                startIcon={<ShoppingBasketTwoToneIcon/>}
                                            >
                                                {Translate.buy}
                                            </Button>
                                            {
                                                (amount >= (!!item.discount_price ? item.discount_price : item.price)) &&
                                                <LoadingButton
                                                    size="small"
                                                    color="primary"
                                                    styleForParent={{width:"100%",marginTop:10}}
                                                    component={"a"}
                                                    href={`${defaultVariabls.website}/buy-plan-wallet/${item.id}`}
                                                    startIcon={<AccountBalanceWalletTwoToneIcon/>}
                                                    loading = {SubmitLoading}
                                                    onClick={() => this.buyWithWallet(item.id)}
                                                >
                                                    {Translate.buyFromWallet}
                                                </LoadingButton>
                                            }
                                        </Card>
                                    </Grid>
                                ))
                            }
                        </Grid>
                }
            </>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(BuyPackage))));
